import { render, staticRenderFns } from "./BusinessManage.vue?vue&type=template&id=4ce4e7b8"
import script from "./BusinessManage.vue?vue&type=script&lang=js"
export * from "./BusinessManage.vue?vue&type=script&lang=js"
import style0 from "./BusinessManage.vue?vue&type=style&index=0&id=4ce4e7b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports